import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'framer-motion';
import classNames from 'classnames';
import useMediaQueries from '@stone/hooks/useMediaQueries';
import Button from '@stone/ui/button/Button';
const EditorialHero = (props) => {
    const { isMobile } = useMediaQueries();
    const isReducedMotion = useReducedMotion();
    const { t } = useTranslation();
    const [readMoreOpen, setReadMoreOpen] = useState(false);
    const [hideHero, setHideHero] = useState(props.hideHero);
    const image = useMemo(() => {
        return (isMobile && props.imageMobile) || props.imageDesktop;
    }, [isMobile]);
    useEffect(() => {
        setHideHero(props.hideHero);
    }, [props.hideHero]);
    const renderHeading = useCallback((hidden) => {
        if (!props.title)
            return null;
        const cssClasses = (hidden && ' visually-hidden') || 'editorial-hero__name font__title';
        return (props.heading === 'h2' && React.createElement("h2", { className: cssClasses }, props.title)) || React.createElement("h1", { className: cssClasses }, props.title);
    }, [props.heading, props.title]);
    const renderSection = () => {
        if (typeof props.backComponent === 'string') {
            return React.createElement("h1", { className: "font__title" }, props.backComponent);
        }
        else {
            return props.backComponent;
        }
    };
    return hideHero ? (React.createElement("div", { className: "editorial-hero--hidden" }, renderHeading(true))) : (React.createElement("div", { className: classNames('editorial-hero'), "data-hero-scroll": "true" },
        React.createElement("div", { className: "branded-image" },
            React.createElement("img", { src: image, alt: "" })),
        React.createElement("div", { className: "container" },
            React.createElement(motion.div, { initial: { y: isReducedMotion ? 0 : 20, opacity: isReducedMotion ? 1 : 0 }, animate: { y: 0, opacity: 1 }, transition: { duration: 0.6, delay: 0.2 }, className: "row" },
                React.createElement("div", { className: "col-lg-5 col-xxl-6 editorial-hero__breadcrumb" }, renderSection()),
                React.createElement("div", { className: "col-lg-8 col-xxl-5 editorial-hero__info" },
                    renderHeading(),
                    React.createElement("div", { className: classNames('editorial-hero__description', { open: readMoreOpen }) },
                        props.description && React.createElement("span", { className: "editorial-hero__description-text", dangerouslySetInnerHTML: { __html: props.description } }),
                        props.descriptionReadMore && (React.createElement(React.Fragment, null,
                            React.createElement("span", null, " "),
                            React.createElement("span", { className: "editorial-hero__read-more-text", dangerouslySetInnerHTML: { __html: props.descriptionReadMore } }),
                            React.createElement(Button, { type: "button", inverted: true, cls: ['button--link-underline'], className: "editorial-hero__read-more-button", onClick: () => {
                                    setReadMoreOpen(!readMoreOpen);
                                } }, t(readMoreOpen ? 'button.readless' : 'button.readmore')))))),
                React.createElement("div", { className: "col-lg-8 offset-lg-3 col-xxl-11 offset-xxl-2 editorial-hero__counters" }, props.rightText && React.createElement("p", { className: "editorial-hero__collection font__title" }, props.rightText))))));
};
EditorialHero.defaultProps = {
    heading: 'h1',
};
export default EditorialHero;
